import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output
} from '@angular/core';

import { Attachment } from '@ui/shared/model';

@Component({
  selector: 'app-attachment-preview',
  templateUrl: './attachment-preview.component.html',
  styleUrls: ['./attachment-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class AttachmentPreviewComponent {
  public readonly imgSrc = input<string>(undefined);
  public readonly isDocument = input(false);
  public readonly attachment = input<Attachment>(undefined);

  public readonly preview = output<Attachment>();
  public readonly download = output<Attachment>();
  isImg = computed(() => this.attachment().type === 'IMG');
  isPdf = computed(
    () =>
      this.attachment().type === 'PDF' ||
      (this.attachment().title &&
        this.attachment().title.toLowerCase().endsWith('.pdf'))
  );
  public previewOpen = false;

  public togglePreview() {
    this.previewOpen = !this.previewOpen;
  }

  public openPreview() {
    this.previewOpen = true;
  }

  public closePreview() {
    this.previewOpen = false;
  }

  public clickOnPdf() {
    const attachment = this.attachment();
    if (attachment.url) {
      this.preview.emit(attachment);
    }
  }

  public clickOnImage() {
    const attachment = this.attachment();
    if (attachment.url) {
      this.download.emit(attachment);
    }
  }
}
